import { useState } from "react";
import { useSession } from "contexts/AuthContext";
import { Text } from "components/text";
import { AlertTriangle, XIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export const OrganisationBanner = () => {
  const { user, organisation } = useSession();
  const [dismissedOrgId, setDismissedOrgId] = useState(
    () => localStorage.getItem("dismissedOrgBanner") || "",
  );
  const { t } = useTranslation(["components"]);

  const orgId = organisation.id;
  const isVisible = dismissedOrgId !== orgId;

  const handleDismiss = () => {
    localStorage.setItem("dismissedOrgBanner", orgId);
    setDismissedOrgId(orgId);
  };

  if (!isVisible) {
    return null;
  }

  if (!user.isSuperAdmin) {
    return null;
  }

  return (
    <div className="bg-system-error/10 px-4 py-2 flex items-center justify-center relative">
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 text-system-error" />
        <Text variant="errorSmall">
          {t("components:banner.organisation.message", {
            name: organisation.name,
          })}
        </Text>
      </div>
      <button
        type="button"
        onClick={handleDismiss}
        className="text-system-error hover:text-system-error/80 transition-colors absolute right-4"
        aria-label="Dismiss banner"
      >
        <XIcon className="h-4 w-4" />
      </button>
    </div>
  );
};
